<template>
  <div class="creation-demand-step-planning">
    <QStepper
      ref="stepper"
      v-model="step"
      active-color="accent"
      done-color="primary"
      :alternative-labels="$q.screen.lt.md"
      header-nav
      color="primary"
      animated
      transition-prev="fade"
      transition-next="fade"
      class="creation-demand-step-planning__stepper"
      @before-transition="updateTransitionState(true)"
      @transition="updateTransitionState(false)"
    >
      <QStep
        v-for="(currentStep, index) in steps"
        :key="index"
        :name="index"
        :title="$t(currentStep.title)"
        :done="step > index"
        :header-nav="step > index"
      >
        <component
          :is="getComponent(currentStep)"
          :ref="index"
          :step-data="planning"
          :step-assets="stepAssets"
          :transition="transition"
          :loading="loading"
          @save-step="saveSubstep"
          @skip="save(true)"
        />
      </QStep>
    </QStepper>
  </div>
</template>

<script>
  import { shallowRef } from "vue";
  import { CreationStepPlanningModel, ICreationStepPlanning } from "@core/models";
  import Dates from "@etab/components/creation/Dates.component.vue";
  import PlanningType from "@etab/components/creation/PlanningType.component.vue";
  import WeekPlanning from "@etab/components/creation/WeekPlanning.component.vue";
  import Week from "@etab/components/creation/Week.component.vue";

  let delay;
  export default {
    components: {
      Dates,
      PlanningType,
      WeekPlanning,
    },
    props: {
      stepAssets: {
        type: Object,
        required: true,
      },
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        step: undefined, // 3 steps
        planning: {},
        transition: false,
        steps: [
          {
            title: "ETAB.PAGES.DEMANDS.CREATION.@PLANNING_DATES_SUBSTEP",
            component: shallowRef(Dates),
          },
          {
            title: "ETAB.PAGES.DEMANDS.CREATION.@PLANNING_TYPE_SUBSTEP",
            component: shallowRef(PlanningType),
          },
          {
            title: "ETAB.PAGES.DEMANDS.CREATION.@PLANNING_HOURS_SUBSTEP",
            component: undefined,
          },
        ],
      };
    },
    beforeUnmount() {
      clearTimeout(delay);
    },
    created() {
      // init a planning model which has both a dates model and a schedule model
      // init step
      this.planning = new CreationStepPlanningModel(this.stepData);
      if (Object.keys(this.stepData).length) {
        // has data, go to final step
        this.step = 2;
      } else {
        this.step = 0;
      }
    },
    methods: {
      updateTransitionState(val) {
        if (val === false) {
          delay = setTimeout(() => {
            this.transition = val;
          }, 500);
        } else {
          this.transition = val;
        }
      },
      goToSubStep(nextStep) {
        this.step = nextStep;
      },
      getComponent(stepObject) {
        // final step is not defined , it can either be week or weekplanning depending on fluctuating key value
        if (!stepObject.component) {
          return this.planning[ICreationStepPlanning.hours] !== undefined ? Week : WeekPlanning;
        }
        return stepObject.component;
      },
      saveSubstep(data) {
        this.planning = new CreationStepPlanningModel({
          ...this.planning,
          ...data,
        });
        if (this.step === 0) {
          // init days object
          this.planning.initFromWeek();
        }
        if (this.step === this.steps.length - 1) {
          this.save();
        } else {
          this.goToSubStep(this.step + 1);
        }
      },
      save() {
        // if days are specified format data by removing id key
        let days;
        if (this.planning[ICreationStepPlanning.days].length) {
          days = this.planning.getDays().map((day) => {
            delete day.id;
            return day;
          });
        }
        // retrieve api formatted date
        const dates = this.planning.getAPIFormattedDates();
        const planning = {
          ...this.planning,
          dates,
          days,
        };
        this.$emit("saveStep", planning);
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-step-planning {
    &__stepper {
      box-shadow: none;
    }
  }
</style>
